import React, { memo } from "react";

import { LottieAnimation } from "@swiggy-private/core-ui";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { SUCCESS_PAGE_TEST_IDS } from "@swiggy-private/payment-test-ids";

import {
    TABLE_RESERVATION_CELEBRATION_LOTTIE_PROPS,
    TABLE_RESERVATION_CELEBRATION_SOUND_TRIGGER_FRAME,
} from "@dineout-payment-success-ui/constants/LottieAnimations";

import useCelebrationSound from "./useCelebrationSound";
import { LottieWrapper } from "./styles";

interface ITableReservationCelebrationHalfCardProps {
    isOpen: boolean;
    onClose: VoidFunction;
    lottieUrl: string;
    soundUrl: string;
    safeAreaBottomPx?: number;
    root?: string;
}

const TableReservationCelebrationHalfCard: React.FC<ITableReservationCelebrationHalfCardProps> = ({
    isOpen,
    onClose,
    lottieUrl,
    soundUrl,
    safeAreaBottomPx = 0,
    root,
}) => {
    const { playSound } = useCelebrationSound(soundUrl);

    if (!isOpen) {
        return null;
    }

    return (
        <HalfCard
            isOpen={isOpen}
            onClose={onClose}
            backgroundColor="background_Secondary"
            hasCustomPadding
            isLightOverlay
            {...(root ? { root } : {})}
        >
            <LottieWrapper
                data-testid={SUCCESS_PAGE_TEST_IDS.CELEBRATION_HALF_CARD}
                safeAreaBottomPx={safeAreaBottomPx}
            >
                <LottieAnimation
                    {...TABLE_RESERVATION_CELEBRATION_LOTTIE_PROPS}
                    fileName={lottieUrl}
                    visible
                    playLottie
                    enableFrameEvent
                    frameEventBreak={TABLE_RESERVATION_CELEBRATION_SOUND_TRIGGER_FRAME}
                    onFrameEventCompletion={playSound}
                />
            </LottieWrapper>
        </HalfCard>
    );
};

export default memo(TableReservationCelebrationHalfCard);
